import { Calendar } from "@msuite/ui/calendar";
import { ChartHeader } from "@msuite/ui/charts";
import { DashboardTile } from "@msuite/ui/dashboard";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useState } from "react";
import { InvoiceStatisticsChart } from "@/components/statistics/invoice-statistics-chart";
import { useInvoiceStatistics } from "@/hooks/use-invoice-statistics";
import type { DashboardTileProps } from "../shared";

export function DashboardYearlyStatisticsItem({ item }: DashboardTileProps) {
	/** Hooks */
	const { t } = useTranslation();
	const controls = Calendar.useControls();
	const [mode, setMode] = useState<"sum" | "cumulative">("sum");

	/** Query */
	const query = {
		startDate: controls.current.startOf("year").format("YYYY-MM-DD"),
		endDate: controls.current.endOf("year").format("YYYY-MM-DD"),
		type: "user" as const,
		truncateType: "week" as const,
	};
	const { queryKey } = useInvoiceStatistics(query);

	/** Render */
	return (
		<DashboardTile item={item}>
			<ChartHeader
				title={t("dashboard.yearly_statistics")}
				description={controls.current.format("YYYY")}
				controls={
					<DashboardTile.Controls
						calendarControls={controls}
						queryKey={queryKey}
						menuItems={[
							{
								label: t("misc.cumulative"),
								isActive: mode === "cumulative",
								onClick: () => setMode("cumulative"),
								icon: icon("AreaChart"),
							},
							{
								label: t("misc.sum"),
								isActive: mode === "sum",
								onClick: () => setMode("sum"),
								icon: icon("BarChart"),
							},
						]}
					/>
				}
			/>
			<InvoiceStatisticsChart
				query={query}
				mode={mode}
			/>
		</DashboardTile>
	);
}
